module.exports = __webpack_public_path__ + "static/img/shuju_bg2.d54ad3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/shuju_bg2.png
// module id = hGtm
// module chunks = 2